<script setup>
import { computed } from 'vue'

import { navigateToService } from '@/composables/navigator'
import { usePlanningStore } from '@/stores/planning.store'
import { usePortalStore } from '@/stores/portal.store'

const props = defineProps({
  serviceIds: { type: Array, default: () => [] },
  warningIds: { type: Array, default: () => [] },
  warningTooltip: { type: String, default: null },
  short: { type: Boolean, default: false },
  justify: { type: String, default: 'flex-start' },
})

const planningStore = usePlanningStore()
const portalStore = usePortalStore()
const serviceTypeIcons = Object.fromEntries(portalStore.getLocalizedServiceTypes().map(type => [type.id, type.icon]))

const chips = computed(() => props.serviceIds
  .map(id => planningStore.getServiceById(id))
  .filter(Boolean)
  .sort((a, b) => (b.type === portalStore.serviceTypeEnum.STAFF) - (a.type === portalStore.serviceTypeEnum.STAFF))
  .map(service => ({
    service,
    label: planningStore.getServiceName(service, props.short),
    warning: props.warningIds.includes(service.id),
  })))
</script>
<template>
  <div class="service-link-chips" :style="{ justifyContent: justify }">
    <q-chip
      v-for="chip in chips"
      :key="chip.service.id"
      dense
      clickable
      size="sm"
      class="q-ma-none"
      :class="{ 'service-link-chips__chip--warning': chip.warning }"
      :icon="chip.warning ? 'mdi-alert-outline' : serviceTypeIcons[chip.service.type]"
      :label="chip.label"
      @click.stop="navigateToService(chip.service)"
    >
      <q-tooltip v-if="chip.warning && warningTooltip">{{ warningTooltip }}</q-tooltip>
    </q-chip>
  </div>
</template>
<style scoped>
.service-link-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  min-width: 0;
}
.service-link-chips__chip--warning {
  background-color: color-mix(in srgb, var(--q-warning) 14%, transparent);
  color: color-mix(in srgb, var(--q-warning) 75%, black);
}
</style>
